<template>
  <div id="new-teacher">
    <div class="container">
      <b-container fluid id="edit-school">
        <div id="alerts">
          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged"
            >You have successfully added a teacher!</b-alert
          >
          <b-alert :show="showError" dismissible variant="warning">
            Something went wrong. Please confirm that you entered at least first
            name, last name, sex, country, region, district and current school.
          </b-alert>
        </div>
        <h1 class="title">{{ title }}</h1>
        <!-- <h4 class="teacher-school">{{ salutation }} {{ lastName }}</h4> -->
        <b-row>
          <b-col>
            <active-input
              plural="teachers"
              singular="teacher"
              :coords="false"
            ></active-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <basic-info singular="teacher" plural="teachers"></basic-info>
          </b-col>
          <b-col>
            <contact-info singular="teacher" plural="teachers"></contact-info>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <geo-info
              plural="teachers"
              singular="teacher"
              :coords="false"
            ></geo-info>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <teacher-education></teacher-education>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <!-- TODO: Add a table and an edit students link for basic info -->
    <!-- <h2 v-if="!this.$route.path.includes('/add')"><router-link :to="{ name: 'EditStudents', params: { id: this.$route.params.id }}">{{ studentTitle }}</router-link></h2> -->
    <div class="container">
      <b-container fluid>
        <br />
        <br />
        <confirm-submit></confirm-submit>
        <b-button
          :size="'lg'"
          :variant="'primary'"
          class="app_school_btn mb-4"
          :disabled="isDisabled"
          @click.prevent="addTeacher"
          >{{ title }}</b-button
        >
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import TeacherService from '@/services/TeacherService';
import BasicInfo from '@/components/BasicInfo';
import ContactInfo from '@/components/ContactInfo';
import GeoInfo from '@/components/GeoInfo';
import ActiveInput from '@/components/ActiveInput';
import TeacherEducation from '@/components/TeacherEducation';
import ConfirmSubmit from '@/components/ConfirmSubmit';

export default {
  name: 'NewTeacher',
  components: {
    BasicInfo,
    ContactInfo,
    GeoInfo,
    ActiveInput,
    TeacherEducation,
    ConfirmSubmit,
  },
  data() {
    return {
      singular: 'teacher',
      plural: 'teachers',
      showError: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      isDisabled: false,
    };
  },
  computed: {
    lastName() {
      if (this.$store.state.teachers.teacher.lastName !== '') {
        return this.$store.state.teachers.teacher.lastName;
      }
      return '';
    },
    teacher_group_id: {
      get() {
        return this.$store.state.trainers.user.teacher_group_id;
      },
      set(val) {
        this.$store.commit('teachers/teacher_group_id', val);
      },
    },
    title() {
      if (this.$route.path.includes('/add')) {
        return 'Add Teacher';
      }
      return 'Edit Teacher';
    },
    salutation() {
      if (this.sex === 'male') {
        return 'Mr.';
      }
      if (this.sex === 'female') {
        return 'Ms.';
      }
      return '';
    },
  },
  methods: {
    ...mapActions({
      CREATE_TEACHER: 'teachers/CREATE_TEACHER',
      RESET_TEACHERS_STATE: 'teachers/RESET_TEACHERS_STATE',
    }),
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    flashSuccess() {
      this.dismissCountDown = this.dismissSecs;
    },
    flashError() {
      this.showError = !this.showError;
    },
    async addTeacher() {
      if (!this.$store.state.confirmed) {
        alert('Please confirm the information above is correct');
        return;
      }
      if (
        this.$store.state.teachers.teacher.first_name.length === 0 ||
        this.$store.state.teachers.teacher.last_name.length === 0 ||
        this.$store.state.teachers.teacher.sex.length === 0||
        this.$store.state.teachers.teacher.district.length === 0||
        this.$store.state.teachers.teacher.country.length === 0||
        this.$store.state.teachers.teacher.region.length === 0
      ) {
        window.scrollTo(0, 0);
        this.flashError();
      } else {
        this.isDisabled = true;
        await this.CREATE_TEACHER();
        window.scrollTo(0, 0);
        await this.flashSuccess();
        await this.RESET_TEACHERS_STATE();
        await this.$store.commit('resetConfirmed');
        // setTimeout(() => this.$router.push({ name: 'TeacherList' }), 1500);
      }
    },
    // TODO: Add a 'add students' method here!
  },
  beforeDestroy() {
    this.RESET_TEACHERS_STATE();
  },
};
</script>

<style scoped>
.container {
  width: 90%;
  align-content: center;
}
.form div {
  margin: 20px;
}
.app_school_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 520px;
  border: none;
  cursor: pointer;
}
label {
  margin-top: 2%;
  margin-bottom: -0.5%;
}
label.left {
  float: left;
}
div.col {
  margin: 1%;
  padding: 1%;
  border: 1px solid gray;
  box-shadow: 3px 2px 2px #b2b2b2;
}
div#assigned-schools {
  float: left;
}
.custom-control-label::before {
  font-size: 10px;
}
.previous-schools {
  list-style-type: none;
  display: inline;
}
.assigned-schools-box {
  max-height: 275px;
  overflow-y: auto;
}
</style>
